module.exports = __webpack_public_path__ + "img/FernseheulenAberHeimlich.e5538452.svg";